import { render, staticRenderFns } from "./Geo.vue?vue&type=template&id=56af36b5&"
import script from "./Geo.vue?vue&type=script&lang=ts&"
export * from "./Geo.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports